// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rVQJRQ{padding:15px 0;line-height:1.5;height:66px}.rVQJRQ .iYY7Dx{color:#bababa}.rVQJRQ.egNbLY{height:auto;padding-top:0;padding-bottom:8px}.rVQJRQ.leJmqD{border-bottom:solid 1px rgba(255,255,255,0.4)}.rVQJRQ.vCsFNQ{height:auto;max-height:80px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rVQJRQ`,
	"live": `iYY7Dx`,
	"is-shrinkable": `egNbLY`,
	"isShrinkable": `egNbLY`,
	"with-separator": `leJmqD`,
	"withSeparator": `leJmqD`,
	"with-live-label": `vCsFNQ`,
	"withLiveLabel": `vCsFNQ`
};
export default ___CSS_LOADER_EXPORT___;
